import React from 'react';
import { VStack, Box, Text } from '@chakra-ui/react';

export const Right = () => {
	return (
		<VStack>
			<Box>
				<Text className='footer-headline'>Come see us</Text>
			</Box>
			<Text className='footer-text'>11660 Alpharetta Hwy #290</Text>
			<Text className='footer-text'>Roswell, GA 30076</Text>
			<Text className='footer-text'>(404) 446-3600</Text>
		</VStack>
	);
};
